import CampaignsList from './components/CampaignsList/CampaignsList';
import { NewFormButton } from './components/NewFormButton';
import { AuthContext } from '@urbanx/agx.auth.client';
import { AgxColumn, AgxHeader } from '@urbanx/agx-ui-components';
import './CampaignsViewPage.scss';
import SidebarLeaderboard from './components/SidebarLeaderboard/SidebarLeaderboard';
import { useTopPerformers } from 'features/reportingDashboard/topPerformersReducer';
import { useContext } from 'react';

const CampaignsViewPage = () => {
  const { userAccount } = useContext(AuthContext);
  const { stats, loading: loadingTopPerformers } = useTopPerformers();

  const agentLeaderboardStat = stats?.individualAndTeamRankings;
  const agencyLeaderboardStat = stats?.agencyRankings;

  return (
    <div className="campaignsViewPage">
      <div className="dashboardTitle">
        <AgxHeader size={1} inverse>
          {`Welcome back, ${userAccount?.firstName || ''}`}
        </AgxHeader>
        <NewFormButton />
      </div>
      <div className="dashboardMain">
        <CampaignsList />
      </div>
      <div className="bodySectionSideBarContainer">
        <AgxColumn extraClasses="sidebarGap">
          <div className="sidebarLeaderboard columnFill first-leaderboard">
            <SidebarLeaderboard
              loading={loadingTopPerformers}
              leaderboardStats={agencyLeaderboardStat}
              boardName="Partners"
            />
          </div>
          <div className="sidebarLeaderboard columnFill">
            <SidebarLeaderboard
              loading={loadingTopPerformers}
              leaderboardStats={agentLeaderboardStat}
              boardName="Performers"
            />
          </div>
        </AgxColumn>
      </div>
    </div>
  );
};

export default CampaignsViewPage;
